import { Editor, TinyMCE } from "tinymce";
import { makeEditorModal } from "../Modal";
import { FeatureClass } from "../core/FeatureClass";
import { displayErrors, getData, getPoints, insertToEditor, pointsValid, setWindowNode, toJsonHtml } from "../core/Utils";
import { generateId, getModalInputId, insertData } from "../save/SaveUtils";
import { inputTransformation } from "../save/Interface";

declare let tinymce:TinyMCE

/**
 * Adds Choosing-Options to editor
 * @param editor 
 */

export function addChoose(editor:Editor){
    const config = {
        featureName: "select-field",
        id: "sf",
        icon: "dropdown",
        tooltip: 'Dropdown erstellen',
        editor: editor,
        menuItems: [{
            name: 'edit-select-field',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                openModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            openModal(editor, command, {points:0, correctIndex: -1, choices: []});
        },
        commandAction: (data:choices) => {
            insertChoose(data);
        }
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}


interface chooseItem {
    answer: string;
}

interface choices {
    id: number;
    type: string;
    points: number;
    correctIndex: number; // index of correct answer
    choices: Array<chooseItem>
}

export function transformSf(data:choices, ind:number):inputTransformation {
    const html = displayCodeSf(data, ind);
    const possible = getSfInfo(data.choices);
    return {
        solution: {
            type: data.type,
            id: data.id,
            points: data.points,
            correct: data.correctIndex,
        },
        html: html,
    }
}

function getSfInfo(choices:Array<chooseItem>){
    const possible = {};
    choices.forEach((item, ind) => {
        possible[ind] = item.answer;
    })
    return possible;
}

function displayCodeSf(data:choices, ind:number){
    const name = generateId(data.id);
    let html = '<select data-id="' + data.id +'" data-type="' + data.type + '" class="form-select input" name="' + name +'"><option value="-1" disabled selected>Auswahl</option>'
    let i = 0;
    data.choices.forEach((item) => {
        html += '<option value="' + i + '">' + item.answer + '</option>'
        i+=1
    })
    html += '</select>';
    return html;
}

function insertChoose(data:choices){

    const html = transformChooseForInsert(data);

    insertToEditor(html);
}

export function transformChooseForInsert(data:choices){
    data.type = "sf";
    const json = toJsonHtml(data);
    let html = '<span id="sf" class="mceNonEditable d-inline-block input-item" data-json="' + json +'">';
    html += renderChooseEditor(data.choices, data.correctIndex);
    html += '</span>';
    return html;
}


function getDataFromModal(modal):choices{
    const errors = [];
    const points = getPoints(modal);
    if (!pointsValid(points)){
        errors.push("Die Eingabe braucht eine gültige Punktzahl");
    }
    const possibleAnswers = modal.find(".choose-row");
    let correctIndex = -1;
    const choices = [];
    possibleAnswers.each((ind, obj) => {
        const isCorrect = $(obj).find(".choose-check").is(":checked"); 
        if (isCorrect){
            correctIndex = ind;
        }
        const answer = $(obj).find(".choose-item").val();
        if (answer != undefined && answer != ''){
            choices.push({
                answer: answer,
            })
        } else {
            errors.push("Antwort fehlt");
        }
    });
    if (possibleAnswers.length < 2){
        errors.push("Man braucht mindestens 2 Antwortmöglichkeiten");
    }

    if (correctIndex == -1){
        errors.push("Bei Auswahlfeldern muss es mindestens eine richtige Antwort geben");
    }

    const id = getModalInputId(modal);

    if (errors.length == 0){
        return {
            points: points,
            choices: choices,
            correctIndex: correctIndex,
            id: id,
            type: 'sf',
        }
    } else {
        displayErrors(errors);
        return false;
    }
}

function getChoices():Array<chooseItem>{
    const modal = $("#create-choices")
    const possibleAnswers = modal.find(".choose-row");
    const choices = [];
    possibleAnswers.each((ind, obj) => {
        const isCorrect = $(obj).find(".choice-check").is(":checked"); 
        const answer = $(obj).find(".choice-item").val();
        choices.push({
            answer: answer,
            correct: isCorrect,
        })
    });
    return choices;
}

function openModal(editor:Editor, command:string, choiceData:choices){
    const choices = (choiceData.choices !== undefined) ? choiceData.choices : [];
    const correctAnswer = (choiceData.correctIndex !== -1) ? choiceData.choices[choiceData.correctIndex].answer : 'Richtige Antwort auswählen';
    let content = '<p class="choice-info">' + 
    renderChooseInfo() + 
    '</p>' +
    '<div class="d-flex align-items-center pb-2 px-1">' +
    '<input type="radio" style="height:26px;visibility:hidden;" name="xd" class="form-control form-check-input">' +
    '<input type="text" id="right-answer" class="w-100 ms-2 form-control form-control-lg" value="' + correctAnswer + '" style="border-radius:0px; border-color: #2cd07e !important;" disabled>' + 
    '<button class="p-2 ms-2 d-inline-flex btn btn-light-danger text-danger" style="visibility: hidden;" type="button"><i class="fa fa-trash"></i></button>' +
    '</div>' +
    '<div id="chooses-wrapper">' + renderChoose(choices, choiceData.correctIndex) + '</div>';
    content += renderAddButton();

    const settings = {
        submitBtn: {
            text: "Einfügen",
            class: "add-choices"
        },
        leftInput: {
            placeholder: "",
            text: "Punkte",
            type: "text",
            value: choiceData.points,
        },
        faq: 17,
        id: choiceData.id,
    }

    const modalId = "create-choose";
    const onclick = function(modal){
        const data = getDataFromModal(modal);
        
        if (data){
            return insertData(data, editor, command, modalId);
        }
    }
    const modal = makeEditorModal(modalId, 'Dropdownaufgabe erstellen', content, settings, onclick, addListeners);
}


function addListeners(modal){
    modal.on("click", ".add-choose", function(){
        const html = renderChooseItem({answer:''}, false);
        $("#chooses-wrapper").append(html);
    });
    modal.on("click", ".remove-choose-item", function(){
        $(this).parent().remove();
    })
    modal.on("change", ".choose-check", function(){
        const text = $(this).next().val();
        modal.find("#right-answer").val(text);
    })
    modal.on("change blur input", ".choose-item", function(){
        if ($(this).prev().is(":checked")){
            const text = $(this).val();
            modal.find("#right-answer").val(text);
        }
    })
}



function renderChoose(items:Array<chooseItem>, correctIndex:number){
    if (items.length == 0){
        items = fillEmptyChoices();
    }
    let html = '';
    let i = 0;
    items.forEach((item) => {
        const correct = i == correctIndex;
        html += renderChooseItem(item, correct);
        i += 1;
    })
    html += '';
    return html;
}

function renderAddButton(){
    const html = '<div class="d-flex justify-content-center align-items-center mb-2 mt-1">' +
    '<button class="btn btn-light-success text-success add-choose"><i class="fa fa-plus-circle"></i> Möglichkeit hinzufügen</button>' + 
    '</div>';
    return html;
}

function renderChooseItem(item:chooseItem, correct:boolean){
    const checked = (correct) ? ' checked' : '';
    // let html = '<div class="d-flex align-items-center py-0 px-1 choose-row">' +
    // '<input type="text" class="w-100 ms-2 choice-item form-control form-control-lg '+checked+'" value="' + item.answer + '" style="border-radius:0px;">' + 
    // '<button class="p-2 ms-2 d-inline-flex btn btn-light-danger text-danger remove-choose-item" type="button"><i class="fa fa-trash"></i></button>' +
    // '</div>';
    const html = '<div class="d-flex align-items-center py-1 px-1 choose-row">' +
    '<input type="radio" style="height:26px;" name="sc" class="form-control form-check-input choose-check"' + checked + '>' +
    '<input type="text" class="w-100 ms-2 choose-item form-control form-control-lg" value="' + item.answer + '" style="border-radius: 0px;">' + 
    '<button class="p-2 ms-2 d-inline-flex btn btn-light-danger text-danger remove-choose-item" type="button"><i class="fa fa-trash"></i></button>' +
    '</div>';

    return html;
}



function renderChooseEditor(items:Array<chooseItem>, correctIndex:number){
    let html = '<select id="sf" class="form-control form-select" style="min-width: 80px;">';
    let i = 0;
    items.forEach((item) => {
        const correct = i == correctIndex;
        html += renderChooseItemEditor(item, correct);
        i += 1
    });
    html += '</select>';
    return html;
}

function renderChooseItemEditor(item:chooseItem, correct:boolean){
    const selected = (correct) ? ' selected' : '';
    const html = '<option ' + selected + '>' + item.answer + '</option>';
    return html;
}



function renderChooseInfo(){
    return 'Du kannst hier ein Dropdown-Auswahlfeld erstellen';
}


function fillEmptyChoices(){
    return [
        {
            answer: '',
            correct: false,
        },
        {
            answer: '',
            correct: false,
        },
        {
            answer: '',
            correct: false,
        }
    ];
}